import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { useContext } from 'react';
import { PermissionsContext } from '../../../context/PermissionsContext';
import { jsx as _jsx } from "react/jsx-runtime";
const DeleteActionButton = ({
  openModal
}) => {
  const {
    canEditSubject
  } = useContext(PermissionsContext);
  return /*#__PURE__*/_jsx(UITooltip, {
    title: canEditSubject ? null : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "cardPaymentHighlight.paymentHighlight.sidebarActions.noAccess.default"
    }),
    children: /*#__PURE__*/_jsx(UIButton, {
      className: "delete-button",
      onClick: openModal,
      "data-test-id": "payment-sidebar-actions--delete",
      disabled: !canEditSubject,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "cardPaymentHighlight.paymentHighlight.sidebarActions.delete.buttonLabel"
      })
    })
  });
};
export default DeleteActionButton;